import { useEffect, useRef } from "react";
import { ArtImagesProps } from "./art-image.types";
import defaultArgImage from '../../assets/default_art_img.svg';
import { Image } from "./art-image.styled";


export const ArtImage: React.FC<ArtImagesProps> = ({ alt, src, className }) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const imageSource = src.trim() || defaultArgImage;

  const handleErrorLoad = () => {
    if (imgRef.current) {
      imgRef.current!.src = defaultArgImage;
    }
  }

  useEffect(() => {
    const imgDom = imgRef.current;
    imgDom?.addEventListener("error", handleErrorLoad);
    return () => imgDom?.removeEventListener("error", handleErrorLoad);
  }, [])

  return <Image ref={imgRef} alt={alt} src={imageSource} className={className} />
}